import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { AppDispatch } from '../store';

import { CatalogOption, CatalogReducer, Catalogs } from './interfaces/CatalogReducer';

const initialState: CatalogReducer = {
  catalogs: {
    tipoSugerencia: [],
    tipoDenunciaMejora: [],
    tipoConducta: [],
    ubicacion: [],
    area: {},
    departamento: {},
    tipoUsuario: [],
    medioComunicacion: [],
    estatus: [],
  },
};

export const catalogSlice = createSlice({
  name: 'foil',
  initialState,
  reducers: {
    setCatalogs: (state, action: PayloadAction<Catalogs>) => {
      state.catalogs = action.payload;
    },
    setEstatus: (state, action: PayloadAction<CatalogOption[]>) => {
      state.catalogs.estatus = action.payload;
    },
    setTipoDenunciaMejora: (state, action: PayloadAction<CatalogOption[]>) => {
      state.catalogs.tipoDenunciaMejora = action.payload;
    },
    setTipoConducta: (state, action: PayloadAction<CatalogOption[]>) => {
      state.catalogs.tipoConducta = action.payload;
    },
  },
});

export const setTipoConducta = async (dispatch: AppDispatch, payload: CatalogOption[]) => {
  dispatch(catalogSlice.actions.setTipoConducta(payload));
};

export const setTipoDenunciaMejora = async (dispatch: AppDispatch, payload: CatalogOption[]) => {
  dispatch(catalogSlice.actions.setTipoDenunciaMejora(payload));
};

export const setCatalogs = async (dispatch: AppDispatch, payload: Catalogs) => {
  dispatch(catalogSlice.actions.setCatalogs(payload));
};

export const setEstatus = async (dispatch: AppDispatch, payload: CatalogOption[]) => {
  dispatch(catalogSlice.actions.setEstatus(payload));
};

const catalogReducer = catalogSlice.reducer;
export const catalogActions = catalogSlice.actions;
export default catalogReducer;
